module.exports = "<p>\r\n    advertiser works!\r\n</p>"


//////////////////
// WEBPACK FOOTER
// ./src/app/advertiser/advertiser.component.html
// module id = 1067
// module chunks = 31